module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAtElEQVRYR+1XQRLAEAyUn7Wf4U18pv2Zjs4wLUbQKIe4kmSzw66AmLxgcn0RABhjDmvtVgIEAKeUci+dac0TAGitLcYGFQBXRyl1104A+A0MTO++b5QBMAPMQMKAExD3tDCh6X1+Pi6us44Uf+2sN34dBmpMpLfLOO7pKU1uOBQAVfLWPOvcgVbkVOdfd2CqEMUfBaoO4zz8IWEGmAGUgT8mo+xgUuOGVJNR1g1HCQ+Wd7oZXckxyCGE0SE0AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/images/扫一扫.png
// module id = 113
// module chunks = 2